import { Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from '@material-ui/core'
import React, { useState } from 'react'
import { contract } from './contract'

interface Props {
  open: boolean
  isLoading: boolean
  onAccept: () => void
  onReject: () => void
}

const TermsAndConditions: React.FC<Props> = ({ open, isLoading, onAccept, onReject }) => {
  const [step, setStep] = useState(0)
  return (
    <Dialog
      open={open}
      onClose={onReject}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Terminos y condiciones</DialogTitle>
      <DialogContent>
        {step === 0 ? (
          <div id="alert-dialog-description">
            <b>Proteccion de datos:</b>
            En cumplimiento de la LEY 1581 DE 2012 de Protección de datos de carácter personal, CO CAPITALIZACIONES SAS,
            como responsable de los datos personales obtenidos a través de sus distintos canales de atención, solicita a
            todas las personas que en algún momento por razones de la actividad que despliega la entidad hayan
            suministrado y/o suministren datos personales, su autorización para que de manera libre, previa, expresa y
            voluntaria permitan continuar con su tratamiento. Tal autorización permitirá a la empresa CO
            CAPITALIZACIONES SAS, recolectar, transferir, almacenar, usar, circular, suprimir, compartir, actualizar y
            transmitir, de acuerdo con el procedimiento para el tratamiento de los datos personales en procura de
            cumplir con las siguientes finalidades: 1. Validar la información en cumplimiento de la exigencia legal de
            conocimiento del REFERENCIADOR, REPRESENTANTE o CLIENTE aplicable a CO CAPITALIZACIONES SAS. 2. Para el
            tratamiento de los datos personales protegidos por nuestro ordenamiento jurídico. 3. Para el tratamiento y
            protección de los datos de contacto (direcciones de correo físico, electrónico, redes sociales y teléfono).
            4. Para formar parte de la base de contactos, de la que es responsable y/o encargado CO CAPITALIZACIONES
            SAS. El alcance de la autorización comprende la facultad para que la empresa CO CAPITALIZACIONES SAS le
            envíe mensajes con contenidos institucionales, notificaciones, y demás información relativa al portafolio de
            servicios de CO CAPITALIZACIONES SAS, a través de correo electrónico y/o mensajes de texto al teléfono
            móvil. Los titulares podrán ejercer sus derechos de conocer, actualizar, rectificar y suprimir sus datos
            personales, a través de los canales dispuestos por CO CAPITALIZACIONES SAS, para la atención al público.
          </div>
        ) : (
          <div>{contract}</div>
        )}
      </DialogContent>
      <DialogActions>
        {step === 1 ? (
          <Button onClick={() => setStep(0)} color="primary">
            Anterior
          </Button>
        ) : null}
        {isLoading ? (
          <CircularProgress />
        ) : step === 1 ? (
          <Button onClick={onAccept} color="primary" variant="contained" autoFocus>
            Aceptar
          </Button>
        ) : (
          <Button onClick={() => setStep(1)} color="primary" variant="contained" autoFocus>
            Siguiente
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default TermsAndConditions
